/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { DnsResourceReferenceOperations } from "../operationsInterfaces";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
import { DnsManagementClient } from "../dnsManagementClient";
import {
  DnsResourceReferenceRequest,
  DnsResourceReferenceGetByTargetResourcesOptionalParams,
  DnsResourceReferenceGetByTargetResourcesResponse
} from "../models";

/** Class containing DnsResourceReferenceOperations operations. */
export class DnsResourceReferenceOperationsImpl
  implements DnsResourceReferenceOperations {
  private readonly client: DnsManagementClient;

  /**
   * Initialize a new instance of the class DnsResourceReferenceOperations class.
   * @param client Reference to the service client
   */
  constructor(client: DnsManagementClient) {
    this.client = client;
  }

  /**
   * Returns the DNS records specified by the referencing targetResourceIds.
   * @param parameters Properties for dns resource reference request.
   * @param options The options parameters.
   */
  getByTargetResources(
    parameters: DnsResourceReferenceRequest,
    options?: DnsResourceReferenceGetByTargetResourcesOptionalParams
  ): Promise<DnsResourceReferenceGetByTargetResourcesResponse> {
    return this.client.sendOperationRequest(
      { parameters, options },
      getByTargetResourcesOperationSpec
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const getByTargetResourcesOperationSpec: coreClient.OperationSpec = {
  path:
    "/subscriptions/{subscriptionId}/providers/Microsoft.Network/getDnsResourceReference",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.DnsResourceReferenceResult
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  requestBody: Parameters.parameters3,
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.$host, Parameters.subscriptionId],
  headerParameters: [Parameters.contentType, Parameters.accept],
  mediaType: "json",
  serializer
};
